import Vue from "vue";
import Vuex from "vuex";
import API_SPOTS from "../../api/spots.api";

Vue.use(Vuex);

export const INITIAL_STATE = {
  spots: [],
};

export default {
  state: () => ({ ...INITIAL_STATE }),
  getters: {
    spots: (state) => state.spots,
  },
  mutations: {
    fetch_spots(state, spots) {
      state.spots = spots ?? [];
    },
  },
  actions: {
    async fetch_spots({ commit, getters }, parkingId) {
      const response = await API_SPOTS.getSpots(
        getters.selectedClient.id,
        parkingId
      );
      commit("fetch_spots", response);
      return response ? "OK" : "KO";
    },

    async post_spot({ getters, dispatch }, data) {
      if (data.id) {
        await API_SPOTS.updateSpot(getters.selectedClient.id, data);
      } else {
        await API_SPOTS.createSpot(getters.selectedClient.id, data);
      }
      await dispatch("fetch_spots", data.parkingid);
      return "OK";
    },

    async delete_spot({ getters, dispatch }, data) {
      await API_SPOTS.deleteSpot(getters.selectedClient.id, data);
      await dispatch("fetch_spots", data.parkingid);
      return "OK";
    },

    /**
     * Delete multiple spots
     * @param {*} param0
     * @param {Array} data - Is an array of spot[{}, {}]
     * @returns String
     */
    async delete_spots({ getters, dispatch }, spotColl) {
      const selectedClient = getters.selectedClient.id;
      const allItemsToDelete = spotColl.map((spot) =>
        API_SPOTS.deleteSpot(selectedClient, spot)
      );
      await Promise.all(allItemsToDelete).then((values) => {
        console.log(values);
      });
      await dispatch("fetch_spots", spotColl[0].parkingid);
      return "OK";
    },
  },
};
